import React, { Component } from 'react';
import $ from 'jquery';


class CancelCFDI extends Component {

    constructor(props) {
        super(props);
        this.state = {
            CancelReason: 0
        }
    }

    componentDidMount() {
        this.closeAction();
    }

    closeConfirm = async () => {
        $('#cancelCFDI').modal('hide');
    }

    closeAction = () => {
        $('#cancelCFDI').on('hidden.bs.modal', function () {
        });
    };

    ChangeCancelReason = async (value) => {
        await this.setState({
            CancelReason: Number(value)
        })
    }



    render() {
        const { CancelReason } = this.state
        const { CancelDocuments, OptionsCancelCFDI = '00' } = this.props;
        return (
            <div className="modal" tabIndex="-1" role="dialog" id="cancelCFDI" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <p>¿Está seguro que deseas cancelar el documento?</p>
                            <select
                                name="select"
                                className="form-control"
                                id="selectCancelCFDI"
                                onChange={(event) => this.ChangeCancelReason(event.target.value)}
                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}>
                                <option value="00" selected>Motivo de cancelación</option>
                                <option value="01">01 - Comprobante emitido con errores con relación</option>
                                <option value="02">02 - Comprobante emitido con errores sin relación</option>
                                <option value="03">03 - No se llevó a cabo la operación</option>
                                <option value="04">04 - Operación nominativa relacionada en la factura global. </option>
                            </select>
                            {(CancelReason && Number(CancelReason) === 1) || OptionsCancelCFDI !== '00' ?
                                <>
                                    <p>UUID Relacionado</p>
                                    <div className="form-row">
                                        <div className="col">
                                            <input type="text" className="form-control"  id="U_FMB_UUID_RELACIONADO" placeholder="UUID Relacionado"></input>
                                        </div>
                                    </div>
                                </>
                                :
                                <></>

                            }

                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn botonCorrect text-black" onClick={() => CancelDocuments()}>Confirmar</button>
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeConfirm}>Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
export default CancelCFDI;